<template>
  <!--DEBUT : LE CLIENT N'A PAS CONTACT MANAGER-->
  <ubi-panel v-if="!this.possedeContactManager && possedeCallTracking === false">
    <h1>{{ $t("contacts.noActivated.title") }}</h1>
    <div style="margin-left: 5%; margin-right: 5%;">
      <h3 class="text-center">
        <strong>{{ $t("contacts.noActivated.title1") }}</strong>
      </h3>
      <br/>
      <p class="text-center" v-html="$t('contacts.noActivated.text1')"/>
      <br/><br/>
      <h3>{{ $t("contacts.noActivated.title2") }}</h3>
      <p class="text-justify">{{ $t("contacts.noActivated.text2") }}</p>
      <br/>
      <h3>{{ $t("contacts.noActivated.title3") }}</h3>
      <p class="text-justify">{{ $t("contacts.noActivated.text3") }}</p>
      <br/>
      <h3>{{ $t("contacts.noActivated.title4") }}</h3>
      <p class="text-justify">{{ $t("contacts.noActivated.text4") }}</p>
      <br/>
      <h3>{{ $t("contacts.noActivated.title5") }}</h3>
      <p class="text-justify">{{ $t("contacts.noActivated.text5") }}</p>
    </div>
    <br />
    <br />
    <div class="text-center">
      <el-row>
        <el-button v-if="!isSubUser" @click="send">{{ $t("contacts.noActivated.beContacted") }}</el-button>
      </el-row>
      <br/>
      <el-row>
        <el-button type="primary" @click="eventAnalytics('decouvrir_produit')">
          <a href="https://lp.ubiflow.net/en-savoir-plus-sur-contact-manager-0" target="_blank"
             id="lienBouton2" rel="noopener">{{ $t("contacts.noActivated.discover") }}</a>
        </el-button>
      </el-row>
    </div>
  </ubi-panel>
  <!--FIN : LE CLIENT N'A PAS CONTACT MANAGER-->
</template>
<script>
import { mapGetters } from 'vuex'
import { sendEmail } from '@/services/email'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPanel from '@/components/Panel.vue'
export default {
  name: 'NoContactManager',
  components: { UbiPanel },
  computed: {
    ...mapGetters(['isSubUser', 'getUser']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return getFromSnake(this.sitimmoUser, 'possede_contact_manager')
    },
    possedeCallTracking () {
      return getFromSnake(this.sitimmoUser, 'possede_call_tracking')
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('contact_manager', 'clic', category, this.sitimmoUser.id)
    },
    async send () {
      this.eventAnalytics('etre_contacte')
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const mailData = {
        to: this.sendTo,
        subject: this.$t('contacts.noActivated.emailSubject', { advertiser: this.getUser.advertiser }),
        email_content: this.$t('contacts.noActivated.emailContent', { advertiser: this.getUser.advertiser, companyName: this.sitimmoUser.nom, email: this.sitimmoUser.email, phoneNumber: this.sitimmoUser.telephone })
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      window.alert('Vous souhaitez des informations sur notre produit Contact Manager. Notre équipe va prendre contact avec vous dans les meilleurs délais')
      this.loading = false
      window.alert(this.$t('contacts.noActivated.dialogMessage'))
    }
  }
}

</script>

<style scoped>

</style>
